import { Box, SxProps, Theme } from '@mui/material';

import { useUserDataStore } from '../../../newStore/userDataStore';

interface IframeProps {
  url: string;
  params?: Record<string, string>;
}

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
    height: '100%',
    '& iframe': {
      flex: 1,
      border: 'none',
    },
  },
};

export function Iframe({ url, params }: IframeProps) {
  const langParam = useUserDataStore((state) => state.lang);

  const paramsString = params
    ? Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
    : '';

  return (
    <Box sx={customStyles.container}>
      <iframe
        src={`${process.env.REACT_APP_BACKEND_ENDPOINT}/${url}?loc=${langParam}${
          paramsString ? `&${paramsString}` : ''
        }`}
      />
    </Box>
  );
}
